import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Parallax } from "@/components/Reveal";

export const PageHero = ({ eyebrow, title, subtitle, image, children }) => {
  const reduce = useReducedMotion();
  return (
    <section className="relative pt-36 lg:pt-44">
      <div className="container-rossi grid lg:grid-cols-12 gap-8 lg:gap-12 items-end pb-10">
        <motion.div className="lg:col-span-7" initial={reduce ? { opacity: 0 } : { opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}>
          {eyebrow && <p className="eyebrow mb-6">{eyebrow}</p>}
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-rossi-cream max-w-4xl leading-[1.04]">{title}</h1>
        </motion.div>
        <div className="lg:col-span-4 lg:col-start-9 border-l border-rossi-cream/15 pl-6">
          {subtitle && <p className="text-base text-rossi-cream/70 leading-relaxed">{subtitle}</p>}
          {children && <div className="mt-6 flex flex-wrap gap-3">{children}</div>}
        </div>
      </div>
      {image && <Parallax src={image} alt={title} className="h-[38vh] sm:h-[48vh] w-full" strength={8} />}
    </section>
  );
};

export default PageHero;
